import { render, staticRenderFns } from "./WorkCooperation.vue?vue&type=template&id=d27daf4c&scoped=true"
import script from "./WorkCooperation.vue?vue&type=script&lang=js"
export * from "./WorkCooperation.vue?vue&type=script&lang=js"
import style0 from "./WorkCooperation.vue?vue&type=style&index=0&id=d27daf4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27daf4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d27daf4c')) {
      api.createRecord('d27daf4c', component.options)
    } else {
      api.reload('d27daf4c', component.options)
    }
    module.hot.accept("./WorkCooperation.vue?vue&type=template&id=d27daf4c&scoped=true", function () {
      api.rerender('d27daf4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Front/IDL/WorkCooperation.vue"
export default component.exports